module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<label class="checkbox">\n    <input type="checkbox" data-layer-name="Высокая вероятность подтверждения">\n    <div class="checkboxStyle"><span class="icon icon-i16_check_thin"></span></div>\n    <span>\n            Высокая вероятность подтверждения\n        <i class="icon-i16_check2 warranted-icon warranted-icon_small js-warranted-icon">\n            <span class="tooltipContent">Отсортируйте результаты поиска для того чтобы быть уверенными в подтверждении вашего бронирования</span>\n        </i>\n    </span>\n</label>\n';
}
return __p;
};
